// ShippingRoute.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

function ShippingRoute() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkShipping = async () => {
      try {
        const { data } = await axios.get('https://apimyshop.myidealtd.co.uk/api/users/shipping', {
          withCredentials: true,
        });

        if (data?.shippingAddress) {
          navigate('/shipping/display');
        } else {
          navigate('/shippingaddress');
        }
      } catch (err) {
        console.error('Error checking shipping address:', err);
        navigate('/shippingaddress');
      }
    };

    if (user) checkShipping();
    else navigate('/login');
  }, [user, navigate]);

  return null;
}

export default ShippingRoute;
